import { collection, doc, orderBy, query } from "firebase/firestore";

import { db } from "lib/firebase";
import { useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore'

export function useEvents() {
    const q = query(collection(db, "events"), orderBy('date', 'desc'))
    const [events, isLoading, error] = useCollectionData(q);
    if (error) throw error;
    return { events, isLoading }
}

export function useEvent(id) {
    const q = doc(db, "events", id)
    const [event, isLoading] = useDocumentData(q);
    return { event, isLoading }
}
